import { message } from 'antd';
import { config } from 'util/config';
import { httpClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';

export function addBySection({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  sectionComponent.child.map((child, i) => {
    if (child.current != null && child.current?.child.current?.props.sectionName === 'ChecklistTemplatePreset') {
      child.current?.setState({ showModal: true, componentType: 'Create' });

      //必须如下顺序设置, 否则再次弹出时无法清空已选项; 新增时无 group 排序, 清空 checklistTemplateGroupSortList
      setTimeout(() => {
        child.current?.customForm.current?.additionalFormRef.current?.child.current?.setState({ defaultSelectedRowKeys: [], filteredData: [], checklistTemplatePresetContentList: [], checklistTemplateGroupSortList: [] });
        child.current?.customForm.current?.additionalFormRef.current?.child.current?.getChecklistTemplateData();
      }, config.setTimeoutMilliSecond * 10);
    }
  })
}

export function editBySection({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  sectionComponent.setState({ showModal: true, componentType: 'Edit' });

  sectionComponent.customForm.current?.additionalFormRef.current?.child.current?.setState({ defaultSelectedRowKeys: [], filteredData: [], data: [], checklistTemplatePresetContentList: [], checklistTemplateGroupSortList: [] });

  setTimeout(() => {
    httpClient
      .get(pageComponent.props.areaName + '/' + sectionName + '/' + parameter.key)
      .then(({ data }) => {
        if (data.result) {
          sectionComponent.customForm.current?.setState({ currentDataKey: data.data.key });

          //把处理后的数据赋值给表单
          sectionComponent.customForm.current?.formRef.current?.setFieldsValue(data.data);
          sectionComponent.customForm.current?.setState({ formData: data.data });

          //获取编辑时的原 checklistTemplatePresetContent 列表, 设置默认选中项 defaultSelectedRowKeys
          let defaultSelectedRowKeys = [];
          let checklistTemplatePresetContentList = [];
          data.data.ChecklistTemplatePresetContentList.map((checklistTemplatePresetContent, i) => {
            defaultSelectedRowKeys.push(checklistTemplatePresetContent.ChecklistTemplateId);
            checklistTemplatePresetContentList.push(checklistTemplatePresetContent);
          })

          //根据已保存的 group 排序构造 group id 数组(后端已按 Sort 升序返回), 供表单按排序显示 group
          let checklistTemplateGroupSortList = [];
          if (data.data.ChecklistTemplatePresetGrorpOrderList) {
            checklistTemplateGroupSortList = data.data.ChecklistTemplatePresetGrorpOrderList
              .slice()
              .sort((a, b) => a.Sort - b.Sort)
              .map((c) => c.ChecklistTemplateGroupId);
          }

          setTimeout(() => {
            sectionComponent.customForm.current?.additionalFormRef.current?.child.current?.setState({ defaultSelectedRowKeys, filteredData: [], checklistTemplatePresetContentList, checklistTemplateGroupSortList });
            //先设置完默认选中项, 再获取实际 ChecklistTemplate 列表, 否则会设置不上
            sectionComponent.customForm.current?.additionalFormRef.current?.child.current?.getChecklistTemplateData();
          }, config.setTimeoutMilliSecond * 10);
        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, pageComponent);
      });
  }, config.setTimeoutMilliSecond);
}

//打开 group 级别排序弹框
export function showChecklistTemplatePresetSortDiv({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  pageComponent.setState({ checklistTemplatePresetSortShow: true, currentChecklistTemplatePreset: parameter });
  pageComponent.checklistTemplatePresetSortDiv.current?.setState({ loading: true });
  setTimeout(() => {
    pageComponent.checklistTemplatePresetSortDiv.current?.loadGroupList(parameter.key);
  }, config.setTimeoutMilliSecond);
}

export function showSelectedItemsOnlyOnChange({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  let filteredData;
  if (parameter) {
    filteredData = sectionComponent.customForm.current?.additionalFormRef.current?.child.current?.state.data.map((folder) => {
      // 使用对象的拷贝
      let newFolder = { ...folder };
      newFolder.ChecklistTemplateGroupList = folder.ChecklistTemplateGroupList.map((group) => {
        // 使用对象的拷贝
        let newGroup = { ...group };
        newGroup.ChecklistTemplateList = group.ChecklistTemplateList.filter((item) =>
          sectionComponent.customForm.current?.additionalFormRef.current?.child.current?.state.checklistTemplatePresetContentList.map(item => item.ChecklistTemplateId).includes(item.key)
        );
        return newGroup;
      });
      return newFolder;
    });
  } else {
    filteredData = [...sectionComponent.customForm.current?.additionalFormRef.current?.child.current?.state.data];
  }
  sectionComponent.customForm.current?.additionalFormRef.current?.child.current?.setState({ filteredData });
}
